import { NgModule } from '@angular/core';

import { CreateAccountStore } from '../../../account/store/create-account.store';
import { Es01StartFlowStore } from './store/es01-start-flow.store';

/**
 * SPD-4426 — wires the ES-01 federated auto-create override into the shared
 * start flow. Importing this module registers the override on init.
 */
@NgModule({
  declarations: [],
  providers: [CreateAccountStore, Es01StartFlowStore],
})
export class Es01StartFlowModule {
  constructor(es01StartFlowStore: Es01StartFlowStore) {
    es01StartFlowStore.initialize();
  }
}
